import $ from 'jquery';
import TweenMax from "gsap";
//
// // // import 文を使って sub.js ファイルを読み込む。
// // import { fadeOut, hello } from "./test/sub";
// //
// // // sub.jsに定義されたJavaScriptを実行する。
// // hello();
var isTablet ;
$(function () {
  let ua = navigator.userAgent;
  isTablet = false;

  if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
  }
  else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      isTablet = true;
  }
  else {

  }
  // console.log(isTablet);
  // TweenMax.to(".label", {
  //   scrollTrigger: ".label", // ".box"がビューポートに入ったらアニメーション開始 (一度だけ)
  //   "max-width" : 900 + "px"
  // });
  // TweenMax.to(".label::after", {
  //   scrollTrigger: ".label::after", // ".box"がビューポートに入ったらアニメーション開始 (一度だけ)
  //   width : 0
  // });
});

$(window).on("scroll", function() {
  scrollAnime();
});
$(window).on("resize", function() {
  edit();
  scrollAnime();
});
$(window).on("load", function() {
  edit();
  $(".loading").fadeOut(600, function() {
    $(".container").css("opacity","1");
    scrollAnime();
  });
});
function edit(){
  var windowWidth = $(window).innerWidth();
  if ( windowWidth > 1250 ){
    $(".mv").height(windowWidth * 0.55);
  }else if ( windowWidth > 750 && windowWidth <= 1250 ){
    $(".mv").height(650);
  }
}
$(".share_icon").on("click", function() {

  let URL = "https://www.asahi.com/ads/selezione-lamborghini/";
  let TITLE = "【ランボルギーニ】中古車認定プログラム「Selezione Lamborghini Certified Pre-Owned」│朝日新聞デジタル";
  let TYPE = $(this).data("type");

  if ($(this).data("page")) {
    URL = URL + $(this).data("page");
    TITLE = $("title").first().text();
  }

  // SNS type
  console.log(TYPE)
  switch (TYPE) {
    case "tw":
      URL = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(TITLE) + "&url=" + URL;
      break;
    case "fb":
      URL = "https://www.facebook.com/sharer/sharer.php?u=" + URL;
      break;
    case "line":
      URL = "https://social-plugins.line.me/lineit/share?url=" + URL;
      break;
    default:
  }

  window.open(URL, TYPE, 'width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=1');
});

$(".slide_thum").on("click", function() {
  TweenMax.to(".slide_preview[data-section='" + $(this).data("section") + "'] img:not([data-id='" + $(this).data("id") + "'])" , 0.1 , {opacity:"0"});

  TweenMax.to(".slide_preview[data-section='" + $(this).data("section") + "'] img[data-id='" + $(this).data("id") + "']" , 0.1 , {opacity:"1"});

  $(".slide_thum[data-section='" + $(this).data("section") + "']").removeClass("selected");
  $(this).addClass("selected");

  // $(".slide_preview[data-section='" + $(this).data("section") + "'] img").attr("src", "img/section_" + $(this).data("section") + "_" + $(this).data("src") + ".jpg");
});

$('a.scroller[href^="#"]').on("click", function() {
  var target = $($(this).attr("href"));
  var position = target.offset().top;

  $('body,html').stop().animate({
    scrollTop: position
  }, 500);
  return false;
});

function scrollAnime() {
  var windowHeight = $(window).innerHeight(),
    windowWidth = $(window).innerWidth(),
    topWindow = $(document).scrollTop(),
    docHeight = $(document).innerHeight(),
    fadeH = 200
    ;

  // console.log("docHeight:" + docHeight);
  // console.log("windowHeight:" + windowHeight);
  // console.log("topWindow:" + topWindow);

  // var ratio = 0;
  // var a = 0;
  // if (windowWidth >= 768 && windowWidth <= 1024 && isTablet) {
  //   ratio = 1400 / windowWidth;
  //   var a = Math.round(windowHeight * ratio);
  // }

  $('.fadein, .slidein').each(function() {
    var targetPosition = $(this).offset().top;

    fadeH = $(this).data("fadeheight") != undefined ? $(this).data("fadeheight") : 200;

    if (topWindow > targetPosition - windowHeight + (fadeH)) {
      $(this).addClass($(this).data("fadein"));
    }
    // if (isTablet && (topWindow + a) >= (docHeight - 100)) {
    //   $(this).addClass($(this).data("fadein"));
    // }

  });
}

  // transition: max-width 0.5s ease-out;
